import { useFormik } from "formik";
import { validationSchema } from "../validations/smryPartners";

export const useFormSmryPartner = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      period: {
        dateFrom: "",
        dateTo: "",
      },
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const dataToSubmit = {
        from: values?.period?.dateFrom,
        to: values?.period.dateTo,
      };

      onSubmit(dataToSubmit);
    },
  });
};
